import { Button } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const addRowAfterCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).addRowAfter().run() : editor.chain().focus().addRowAfter().run();

const AddRowAfter = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<ArrowDownOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => addRowAfterCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_ADD_ROW_AFTER" defaultMessage="Add row after" />
        </div>
      )}
    </Button>
  );
};

export default AddRowAfter;
